module.exports = __webpack_public_path__ + "static/media/Avatar.cc27498e.jpg";